import React, { useEffect, useState } from 'react';
import './AdminDashboardPage.css';
import Can from '../../permissions/Can.js';
import AdminNavbar from '../../ui/AdminNavbar/AdminNavbar';
import { useDispatch } from 'react-redux';
import {
  getSessionsAsync,
  getUsersAsync,
  getUsers,
  getRolesAsync,
  getRoles,
  getApplicationsAsync,
  getApplications,
  getCredentialsAsync,
  getCredentials,
} from '../../../features/redux/adminSlice';
import { getSessions } from '../../../features/redux/adminSlice';
import { useSelector } from 'react-redux';
import UserPage from '../UserPage/UserPage';
import CredentialsPage from '../CredentialsPage/CredentialsPage';
import ApplicationsPage from '../ApplicationsPage/ApplicationsPage';
import SessionsPage from '../SessionsPage/SessionsPage';

function AdminDashboardPage() {
  const dispatch = useDispatch();
  const users = useSelector(getUsers);
  const roles = useSelector(getRoles);
  const credentials = useSelector(getCredentials);
  const applications = useSelector(getApplications);
  const [activeTab, setActiveTab] = useState('users');

  useEffect(() => {
    dispatch(getUsersAsync());
    dispatch(getRolesAsync());
    dispatch(getApplicationsAsync());
    dispatch(getCredentialsAsync());
  }, []);

  return (
    <div className='admin-dashboard-wrapper'>
      <Can action='admin-dashboard'>
        <AdminNavbar activeTab={activeTab} setActiveTab={setActiveTab} />

        {activeTab == 'sessions' && (
          <SessionsPage
            users={users}
            applications={applications}
            credentials={credentials}
          />
        )}
        {activeTab == 'users' && (
          <UserPage users={users} roles={roles} applications={applications} />
        )}
        {activeTab == 'credentials' && (
          <CredentialsPage
            credentials={credentials}
            applications={applications}
          />
        )}
        {activeTab == 'applications' && (
          <ApplicationsPage
            credentials={credentials}
            applications={applications}
          />
        )}
      </Can>
    </div>
  );
}

export default AdminDashboardPage;
